import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient } from '@/apiClient.ts'

type AddCalendarEventRequest = InferRequestType<
  typeof apiClient.calendar.events.$post
>['json']
type AddCalendarEventResponse = InferResponseType<
  typeof apiClient.calendar.events.$post
>

export const useAddCalendarEvent = (
  options?: UseMutationOptions<
    AddCalendarEventResponse,
    Error,
    AddCalendarEventRequest
  >
) =>
  useMutation({
    mutationKey: ['add-calendar-event'],
    mutationFn: (variables) => {
      return apiClient.calendar.events
        .$post({
          json: variables,
        })
        .then(async (r) => r.json())
    },
    ...options,
  })
